import hero from "../assets/images/StorePic.jpg";

function HeroImage() {
  return <img src={hero} alt="Home" className="w-100 heroImage" />;
}

export default HeroImage;
